import { Box, Link, Typography } from '@mui/material'
import React from 'react'

const Disclaimer: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" padding={1}>
      <Typography variant="h1">XYO World 2.0 Fork</Typography>
      <Typography variant="body1">
        After the first mint of an XYOW NFT, we discovered a critical bug that did not align with the established payout mathematics of XYO World.
        Consequently, the XYO Foundation has decided to make an XYO World 2.0 Fork.
      </Typography>
      <Typography variant="body1">
        This means that the previous contract stays out there (call it XYO World Classic if you want), but we will treat the new contract as the
        authority going forward.
      </Typography>
      <Typography variant="body1">
        I apologize for this, but I would much rather fix this right up front rather than letting the system run without fixing it. The cost to the
        XYO Foundation for having to make this change is over 14M XYO and close to 3 ETH (for deployment). The XYO is required to make good on the
        current state of the contract for the NFT holders and high bidders.
      </Typography>
      <Typography variant="body1">
        This page describes the changes in detail to provide as much transparency as possible. If you have any questions, you can find me on Twitter
        at{' '}
        <Link href="https://twitter.com/arietrouw" target="_blank">
          @arietrouw
        </Link>
        , or you can email our{' '}
        <Link href="https://support.xyo.network" target="_blank">
          support team
        </Link>
        .
      </Typography>
      <Typography variant="body1">- Arie Trouw</Typography>
    </Box>
  )
}

export default Disclaimer
